<template>
  <div class="sidebar">
    <div class="menu">
      <!-- 系统设置 -->
      <div class="menu-group" v-if="getAllMenuCodes.includes('4ZJYxKnW')">
        <div class="menu-group-title" @click="toggleGroup('system')" need-listen data-event-name="toggleSystem">
          <i class="el-icon-setting"></i>
          <span>系统设置</span>
          <i
            class="el-icon-arrow-down"
            :class="{ 'is-active': activeGroups.system }"
          ></i>
        </div>
        <div class="menu-group-items" v-show="activeGroups.system">
          <div
            class="menu-item"
            v-if="isDev"
            :class="{ 'is-active': $route.path === '/management/menu' }"
            @click="$router.push('/management/menu')" need-listen data-event-name="goMenuManagement"
          >
            <i class="el-icon-menu"></i>
            <span>菜单管理</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('hYs7xhSl')"
            :class="{ 'is-active': $route.path === '/management/roles' }"
            @click="$router.push('/management/roles')" need-listen data-event-name="goRoleManagement"
          >
            <i class="el-icon-user"></i>
            <span>角色管理</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('4rhW8qOe')"
            :class="{ 'is-active': $route.path === '/management/accounts' }"
            @click="$router.push('/management/accounts')" need-listen data-event-name="goAccountManagement"
          >
            <i class="el-icon-s-custom"></i>
            <span>账号管理</span>
          </div>
        </div>
      </div>

      <!-- 基础配置 -->
      <div class="menu-group" v-if="getAllMenuCodes.includes('EhWXpycK')">
        <div class="menu-group-title" @click="toggleGroup('basic')" need-listen data-event-name="toggleBasic">
          <i class="el-icon-s-tools"></i>
          <span>基础配置</span>
          <i
            class="el-icon-arrow-down"
            :class="{ 'is-active': activeGroups.basic }"
          ></i>
        </div>
        <div class="menu-group-items" v-show="activeGroups.basic">
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('PtpT4xMZ')"
            :class="{ 'is-active': $route.path === '/management/strawberry' }"
            @click="$router.push('/management/strawberry')" need-listen data-event-name="goStrawberryManagement"
          >
            <i class="el-icon-cherry"></i>
            <span>草莓品种配置</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('YZgegHAl')"
            :class="{ 'is-active': $route.path === '/management/greenhouse' }"
            @click="$router.push('/management/greenhouse')" need-listen data-event-name="goGreenhouseManagement"
          >
            <i class="el-icon-house"></i>
            <span>大棚编号配置</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('LWXl3Iod')"
            :class="{ 'is-active': $route.path === '/management/growth' }"
            @click="$router.push('/management/growth')" need-listen data-event-name="goGrowthManagement"
          >
            <i class="el-icon-timer"></i>
            <span>生长时期名称</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('j0l5WhpG')"
            :class="{ 'is-active': $route.path === '/management/tasks' }"
            @click="$router.push('/management/tasks')" need-listen data-event-name="goTasksManagement"
          >
            <i class="el-icon-notebook-1"></i>
            <span>农事任务分类</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('ShFPEZUO')"
            :class="{ 'is-active': $route.path === '/management/storagePositions' }"
            @click="$router.push('/management/storagePositions')" need-listen data-event-name="goStoragePositionsManagement"
          >
            <i class="el-icon-s-shop"></i>
            <span>仓储位置配置</span>
          </div>
        </div>
      </div>

      <!-- 农事配置 -->
      <div class="menu-group" v-if="getAllMenuCodes.includes('Qg1i464x')">
        <div class="menu-group-title" @click="toggleGroup('farm')" need-listen data-event-name="toggleFarm">
          <i class="el-icon-s-management"></i>
          <span>农事配置</span>
          <i
            class="el-icon-arrow-down"
            :class="{ 'is-active': activeGroups.farm }"
          ></i>
        </div>
        <div class="menu-group-items" v-show="activeGroups.farm">
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('pLUSo608')"
            :class="{
              'is-active': $route.path === '/management/growth-period',
            }"
            @click="$router.push('/management/growth-period')" need-listen data-event-name="goGrowthPeriodManagement"
          >
            <i class="el-icon-date"></i>
            <span>生长时期配置</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('XwWWdXRl')"
            :class="{ 'is-active': $route.path === '/management/farm-tasks' }"
            @click="$router.push('/management/farm-tasks')" need-listen data-event-name="goFarmTasksManagement"
          >
            <i class="el-icon-s-order"></i>
            <span>农事任务配置</span>
          </div>
        </div>
      </div>
      <div class="menu-group" v-if="getAllMenuCodes.includes('DPhPDoVS')">
        <div class="menu-group-title" @click="toggleGroup('dev')" need-listen data-event-name="toggleDev">
          <i class="el-icon-s-management"></i>
          <span>设备管理</span>
          <i
            class="el-icon-arrow-down"
            :class="{ 'is-active': activeGroups.dev }"
          ></i>
        </div>
        <div class="menu-group-items" v-show="activeGroups.dev">
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('awaFx4jQ')"
            :class="{
              'is-active': $route.path === '/management/realTimeMonitoring',
            }"
            @click="$router.push('/management/realTimeMonitoring')" need-listen data-event-name="goRealTimeMonitoringManagement"
          >
            <i class="el-icon-monitor"></i>
            <span>实时监控</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('mL5z4LGk')"
            :class="{
              'is-active': $route.path === '/management/equipmentControl',
            }"
            @click="$router.push('/management/equipmentControl')" need-listen data-event-name="goEquipmentControlManagement"
          >
            <i class="el-icon-s-tools"></i>
            <span>智控设备</span>
          </div>
          <!-- 检测设备 -->
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('bmYskUz6')"
            :class="{
              'is-active': $route.path === '/management/monitoringEquipment',
            }"
            @click="$router.push('/management/monitoringEquipment')" need-listen data-event-name="goMonitoringEquipmentManagement"
          >
            <i class="el-icon-s-data"></i>
            <span>监测设备</span>
          </div>
          <!-- 调度页面配置 -->
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('nMw0b7cD')"
            :class="{
              'is-active': $route.path === '/management/schedulingPage',
            }"
            @click="$router.push('/management/schedulingPage')" need-listen data-event-name="goSchedulingPageManagement"
          >
            <i class="el-icon-s-order"></i>
            <span>数据监测背景设置</span>
          </div>
        </div>
      </div>
      <div class="menu-group" v-if="getAllMenuCodes.includes('X0ODJwXJ')">
        <div class="menu-group-title" @click="toggleGroup('big')" need-listen data-event-name="toggleBig">
          <i class="el-icon-s-management"></i>
          <span>调度大屏配置</span>
          <i
            class="el-icon-arrow-down"
            :class="{ 'is-active': activeGroups.big }"
          ></i>
        </div>
        <div class="menu-group-items" v-show="activeGroups.big">
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('ClO74k3K')"
            :class="{
              'is-active': $route.path === '/management/IndustryAndProvenance',
            }"
            @click="$router.push('/management/IndustryAndProvenance')" need-listen data-event-name="goIndustryAndProvenanceManagement"
          >
            <i class="el-icon-monitor"></i>
            <span>产地和种源</span>
          </div>
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('tOerk6Ja')"
            :class="{ 'is-active': $route.path === '/BaseIntroduction' }"
            @click="$router.push('/management/BaseIntroduction')" need-listen data-event-name="goBaseIntroductionManagement"
          >
            <i class="el-icon-s-tools"></i>
            <span>各基地介绍</span>
          </div>
          <!-- 生长时期图片 -->
          <div
            class="menu-item"
            v-if="getAllMenuCodes.includes('IwJzb3iy')"
            :class="{
              'is-active': $route.path === '/management/growthPictures',
            }"
            @click="$router.push('/management/growthPictures')" need-listen data-event-name="goGrowthPicturesManagement"
          >
            <i class="el-icon-s-data"></i>
            <span>生长时期图片</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ManagementHeader",
  data() {
    return {
      activeGroups: {
        system: true,
        basic: false,
        farm: false,
        dev: false,
        big: false,
      },
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    ...mapGetters("user", ["getAllMenuCodes"]),
    isDev() {
      console.log("userInfo", this.userInfo);
      const roleIds = this.userInfo.roleIds.split(",");
      return roleIds.includes("1");
    },
  },
  mounted() {
    console.log("getAllMenuCodes", this.getAllMenuCodes);
  },
  methods: {
    toggleGroup(group) {
      this.activeGroups[group] = !this.activeGroups[group];
    },
  },
};
</script>

<style lang="less">
.sidebar {
  width: 220px;
  height: calc(100vh - 148px);
  overflow-y: auto;
  overflow-x: hidden;
  background: rgba(0, 11, 47, 0.8);
  box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
  color: #fff;

  // 自定义滚动条样式，隐藏滚动条
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  .menu {
    padding: 10px 0;

    .menu-group {
      margin-bottom: 4px;

      .menu-group-title {
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: all 0.3s;

        &:hover {
          background: rgba(0, 124, 255, 0.2);
        }

        i {
          margin-right: 8px;
          font-size: 18px;

          &.el-icon-arrow-down {
            margin-left: auto;
            margin-right: 0;
            transition: transform 0.3s;
            font-size: 12px;

            &.is-active {
              transform: rotate(180deg);
            }
          }
        }
      }

      .menu-group-items {
        .menu-item {
          padding: 14px 20px 14px 44px;
          cursor: pointer;
          transition: all 0.3s;
          line-height: 1.5;
          display: flex;
          align-items: center;

          i {
            margin-right: 8px;
            font-size: 16px;
          }

          &:hover {
            background: rgba(0, 124, 255, 0.2);
          }

          &.is-active {
            background: rgba(0, 124, 255, 0.3);
            color: #409eff;
          }
        }
      }
    }
  }
}
</style>
